export default ({ request }) => ({
  ecomAmzSpuListApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/list',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuDetailApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuSaveApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/save',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuDelApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/del',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuApplyApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/apply',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuApprovedApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/approved',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuRejectApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/reject',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuBindSpuBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/bindSpuBySpuCode',
      method: 'post',
      data,
    })
  },
  ecomAmzSpuAddSkuApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/add/sku',
      method: 'post',
      data,
    })
  },

  // SPU 产品图片
  ecomAmzSpuImageListApi(data = {}) {
    return request({
      url: '/ecom/amz/spu/image/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuImageUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/spu/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/amz/spu/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuImageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/spu/image/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuCategoryApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/category',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuNewCollectionApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/new/collection',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuRemoveSkuApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/removeSku',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuFullMemberApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/changeDesign',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuChangeMerchandiserApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/changeMerchandiser',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuChangeName(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/changeName',
      method: 'POST',
      data,
    })
  },
  ecomAmzSpuFlipListApi(data = {}) {
    return request({
      url: '/ecom/ecom/amz/spu/flip/list',
      method: 'post',
      data,
    })
  },
})
